import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2fd903c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:w-[70%] w-full 2xl:w-[60%] bg-white text-black" }
const _hoisted_2 = { class: "flex items-center py-12 px-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mr-36 font-semibold text-3xl" }, "Location Usage", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col w-full p-20",
  "aria-label": "Loading data"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-[292px] rounded-sm bg-gray-200 mb-10 animate-pulse2" }, null, -1))
const _hoisted_6 = { class: "grid grid-cols-4 gap-8" }
const _hoisted_7 = { class: "h-42 rounded-sm bg-gray-200 mb-5 animate-pulse2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chartBox" }, [
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "chart-stacked",
    class: "sm:p-12 p-6 bg-white"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(_ctx.vehicleChargeData) + " Vehicles Charged", 1)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (_) => {
              return _createElementVNode("div", _hoisted_7)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({ hidden: _ctx.isLoading })
    }, _hoisted_9, 2)
  ]))
}